import { useEffect, useState } from 'react';

import { REFETCH_AGENT_RUN_INTERVAL } from '@/constants';
import { toFileId, toPredictionId, useGetFile, useGetPrediction } from '@/hooks/api';
import { JSONType } from '@/utils';

export type UsePredictionAnnotationsOpts = {
  predictionId?: string | null;
};

export const usePredictionAnnotations = ({ predictionId }: UsePredictionAnnotationsOpts) => {
  const { data: prediction, isPending: isPendingPrediction } = useGetPrediction(toPredictionId(predictionId), {
    refetchInterval: (query) => (query.state.data?.status === 'pending' ? REFETCH_AGENT_RUN_INTERVAL : undefined),
  });

  const { data: file, isPending: isPendingFile } = useGetFile(toFileId(prediction?.fileUrl));
  const [annotations, setAnnotations] = useState<JSONType | undefined>();
  const [lastModified, setLastModified] = useState<Date | undefined>();

  useEffect(() => {
    if (!file) return;

    setAnnotations(undefined);
    setLastModified(undefined);

    file.text().then((annotationsStr) => {
      setAnnotations(JSON.parse(annotationsStr));
      setLastModified(new Date(file.lastModified));
    });
  }, [file]);

  return { annotations, isPending: isPendingPrediction || isPendingFile, lastModified };
};
